module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-03@2x.c8a2cd01.jpg";